<div class="container main-container">
  <div class="form-group">
    <input
      class="form-control"
      [(ngModel)]="textoPesquisa"
      id="textoPesquisa"
      type="text"
      placeholder="escreva o titulo da questão"
      [ngModelOptions]="{standalone: true}"
    />
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="categorizadas"
        [(ngModel)]="categorizadas"
        [ngModelOptions]="{standalone: true}"
      />
      <label class="form-check-label" for="flexCheckDefault">
        Categorizadas
      </label>
    </div>
  </div>

  <div class="form-group">
    <div class="col-md-10">
      <span>
        <button
          class="btn btn-success"
          id="pesquisar"
          type="button"
          (click)="pesquisar()"
          (disabled)="(disabled)"
        >
          Pesquisar
        </button>
      </span>
    </div>
  </div>
  <div id="paging">
    <div class="jumbotron">
      <div class="list">
        <ul>
          <li *ngFor="let item of questoes | paginate: config">
            <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
              <ngb-panel id="custom-panel-1">
                <ng-template ngbPanelHeader let-opened="opened">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <button
                      ngbPanelToggle
                      class="btn btn-link container-fluid text-left pl-0"
                    >
                      {{ item.titulo }}
                    </button>
                    <a [routerLink]="['/questao/editar', item.id]">Editar</a>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div [innerHtml]="item.texto"></div>

                  <p>
                    {{ item.componenteCurricular?.nome }}
                  </p>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </li>
        </ul>
        <pagination-controls
          [maxSize]="20"
          [autoHide]="true"
          [responsive]="true"
          [previousLabel]="labels.previousLabel"
          [nextLabel]="labels.nextLabel"
          [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
          [screenReaderPageLabel]="labels.screenReaderPageLabel"
          [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
          (pageChange)="pageChange($event)"
        >
        </pagination-controls>
      </div>
    </div>
  </div>
</div>
